<template>
  <div class="animated fadeIn">
    <soil-sample-form-group
      v-for="(sample, index) in collection"
      :key="index"
      :sample="sample"
      :index="index"
      :allTestPackages="allTestPackages"
      @onSampleChange="onSampleChange"
    ></soil-sample-form-group>
  </div>
</template>

<script>
import SoilSampleFormGroup from "./SoilSampleFormGroup";

export default {
  name: "SoilSampleFormGroups",
  components: { SoilSampleFormGroup },
  props: {
    samples: {
      type: Object,
      default: () => null
    },
    index: {
      type: Number
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      collection: []
    };
  },
  methods: {
    onSampleChange(params) {
      if (params) {
        let sample = params.sample;
        let index = params.index;
        if (sample && index !== null) {
          this.collection.splice(index, 1, sample);
          this.$emit("onSamplesChange", this.collection);
        }
      }
    }
  },
  watch: {
    samples: {
      handler(value) {
        if (value && value.length) {
          this.collection = value;
        }
      },
      deep: true
    }
  },
  created() {
    if (this.samples && this.samples.length) {
      this.collection = this.samples;
    }
  }
};
</script>
